import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';

@Component({
  selector: 'app-new-data-explorer',
  templateUrl: './new-data-explorer.component.html',
  styleUrls: ['./new-data-explorer.component.scss']
})
export class NewDataExplorerComponent implements OnInit, OnDestroy {
  // Panel state management
  public leftPanelFullscreen = false;
  public rightPanelFullscreen = false;
  public leftPanelWidth = 33;
  public rightPanelWidth = 67;
  private isResizing = false;

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    // Main component initialization
  }

  ngOnDestroy(): void {
    // Cleanup if needed
  }

  // Panel fullscreen toggle methods
  onToggleLeftPanelFullscreen(): void {
    this.leftPanelFullscreen = !this.leftPanelFullscreen;
    this.rightPanelFullscreen = false; // Ensure only one panel is fullscreen at a time
    this.cdr.detectChanges();
  }

  onToggleRightPanelFullscreen(): void {
    this.rightPanelFullscreen = !this.rightPanelFullscreen;
    this.leftPanelFullscreen = false; // Ensure only one panel is fullscreen at a time
    this.cdr.detectChanges();
  }

  // Resizing functionality
  startResize(event: MouseEvent): void {
    this.isResizing = true;
    const startX = event.clientX;
    const startLeftWidth = this.leftPanelWidth;
    const startRightWidth = this.rightPanelWidth;

    const doResize = (e: MouseEvent) => {
      if (!this.isResizing) return;
      
      const deltaX = e.clientX - startX;
      const containerWidth = window.innerWidth;
      const deltaPercent = (deltaX / containerWidth) * 100;
      
      let newLeftWidth = startLeftWidth + deltaPercent;
      let newRightWidth = startRightWidth - deltaPercent;
      
      // Constrain to minimum and maximum widths
      const minWidth = 33; // 33% minimum
      const maxWidth = 67; // 80% maximum
      
      if (newLeftWidth < minWidth) {
        newLeftWidth = minWidth;
        newRightWidth = 100 - minWidth;
      } else if (newLeftWidth > maxWidth) {
        newLeftWidth = maxWidth;
        newRightWidth = 100 - maxWidth;
      } else if (newRightWidth < minWidth) {
        newRightWidth = minWidth;
        newLeftWidth = 100 - minWidth;
      } else if (newRightWidth > maxWidth) {
        newRightWidth = maxWidth;
        newLeftWidth = 100 - maxWidth;
      }
      
      this.leftPanelWidth = newLeftWidth;
      this.rightPanelWidth = newRightWidth;
      this.cdr.detectChanges();
    };

    const stopResize = () => {
      this.isResizing = false;
      document.removeEventListener('mousemove', doResize);
      document.removeEventListener('mouseup', stopResize);
      document.body.style.cursor = '';
      document.body.style.userSelect = '';
    };

    document.addEventListener('mousemove', doResize);
    document.addEventListener('mouseup', stopResize);
    document.body.style.cursor = 'col-resize';
    document.body.style.userSelect = 'none';
    event.preventDefault();
  }
}
